import React from "react";

export const BenefitsSection = () => {
    const benefits = [
        {
            title: "Fast-track Your Listing",
            description:
                "Get your tool listed within 48 hours with our priority review process, bypassing the standard queue.",
            icon: (
                <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                </svg>
            ),
        },
        {
            title: "SEO Power Boost",
            description:
                "Get high-quality dofollow backlinks to your website, significantly improving your search engine rankings and organic traffic.",
            icon: (
                <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                    />
                </svg>
            ),
        },
        {
            title: "Lifetime Exposure",
            description:
                "Your tool remains permanently listed, continuously attracting new users and generating sustainable traffic to your platform.",
            icon: (
                <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>
            ),
        },
        {
            title: "Enhanced Visibility",
            description:
                "Stand out in search results with featured placement and optimized listing that drives more traffic to your tool.",
            icon: (
                <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                </svg>
            ),
        },
    ];

    return (
        <div className="w-full bg-gray-50 rounded-lg overflow-hidden mb-8">
            <div className="relative h-48 sm:h-64">
                <img
                    src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
                    alt="Benefits background"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-blue-600 bg-opacity-75 flex items-center justify-center">
                    <h2 className="text-3xl font-bold text-white text-center px-4">
                        Submit a Tool
                    </h2>
                </div>
            </div>
            <div className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {benefits.map((benefit, index) => (
                        <div key={index} className="flex items-start space-x-4">
                            <div className="flex-shrink-0">
                                <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-500 text-white">
                                    {benefit.icon}
                                </div>
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900">
                                    {benefit.title}
                                </h3>
                                <p className="mt-1 text-gray-600">
                                    {benefit.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
